<template>
  <div>
    <v-input
      class="v-text-field v-text-field--is-booted"
      :class="inputClass"
      :rules="rules"
    >
      <fieldset v-if="this.outlined" aria-hidden="true">
        <legend style="color: transparent" :style="{ 'width': labelWidth + 'px' }">|</legend>
      </fieldset>
      <div class="v-text-field__slot">
        <label ref='ref_label' for="input-66" class="v-label theme--light" :class="{ 'v-label--active': isFocused || value || value === 0, 'primary--text': isFocused }" style="left: 0px; right: auto; position: absolute;">{{ label }}</label>
        <currency-input
          id="input-66"
          :value="value"
          v-bind="options"
          :disabled="disabled"
          @input="$emit('input', $event)"
          @focus="isFocused = true; $emit('focus', $event)"
          @blur="isFocused = false; $emit('blur', $event)"
          @keydown="$emit('keydown', $event)"
          @keyup="$emit('keyup', $event)"
          @keypress="$emit('keypress', $event)"
        />
      </div>
    </v-input>
  </div>
</template>

<script>
import { CurrencyInput, CurrencyDirective } from 'vue-currency-input'

export default {
  components: { CurrencyInput },
  directives: {
    currency: CurrencyDirective
  },
  data () {
    return {
      isFocused: false,
      options: {
        locale: 'pt-br',
        currency: 'BRL',
        distractionFree: false,
        autoDecimalMode: true
      }
    }
  },
  props: {
    value: {
      type: [String, Number],
      default: '0'
    },
    label: {
      type: String,
      default: ''
    },
    rules: {
      type: Array,
      default: () => []
    },
    outlined: {
      type: Boolean
    },
    dense: {
      type: Boolean
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    inputClass () {
      let inputClass = (this.isFocused) ? 'v-input--is-focused primary--text' : ''
      if (this.outlined) inputClass += ' v-text-field--outlined v-text-field--enclosed'
      if (this.dense) inputClass += ' v-input--dense'
      return inputClass
    },
    labelWidth () {
      return ((this.isFocused || this.value || this.value === 0) && this.$refs.ref_label) ? this.$refs.ref_label.offsetWidth * 0.8 + 1 : 0
    }
  }
}
</script>
